import { useCallback, useRef } from "react";

/**
 * Lightweight 3D-tilt hook (no deps).
 * Attach ref to a container; on mousemove within it, we translate a CSS
 * transform based on the pointer's relative position. Reset on leave.
 */
export const useTilt = ({ max = 8, scale = 1.02 } = {}) => {
  const ref = useRef(null);

  const onMouseMove = useCallback(
    (e) => {
      const node = ref.current;
      if (!node) return;
      const rect = node.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width - 0.5;
      const py = (e.clientY - rect.top) / rect.height - 0.5;
      const rx = -py * max;
      const ry = px * max;
      node.style.transform = `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg) scale(${scale})`;
      node.style.setProperty("--tilt-mx", `${(px + 0.5) * 100}%`);
      node.style.setProperty("--tilt-my", `${(py + 0.5) * 100}%`);
    },
    [max, scale]
  );

  const onMouseLeave = useCallback(() => {
    const node = ref.current;
    if (!node) return;
    node.style.transform = "perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)";
    node.style.setProperty("--tilt-mx", `50%`);
    node.style.setProperty("--tilt-my", `50%`);
  }, []);

  return { ref, onMouseMove, onMouseLeave };
};

export default useTilt;
